import { render } from "./HeaderApp.vue?vue&type=template&id=04fd3846&scoped=true&ts=true"
import script from "./HeaderApp.ts?vue&type=script&lang=ts"
export * from "./HeaderApp.ts?vue&type=script&lang=ts"

import "./HeaderApp.scss?vue&type=style&index=0&id=04fd3846&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04fd3846"]])

export default __exports__